import React from 'react';
import logo from './logo.svg';
import { BrowserRouter as Router, Route, Switch } from
  'react-router-dom'
import './App.css';
import PrivateRoute from "./private-route/route.private"
import Dashboard from "./dashboard/dashboard"
import Search from "./search/search"
import Login from "./auth/login"
import testModal from "./table/testmodal"
import register from "./register/register"
import createrole from "./createrole/createrole"
import passwordreset from "./passwordreset/passwordreset"
import { savedetails } from './api/api.list';
// import datatable from "./datatable/datatable"




function App() {

 
  return (
    <Router>
      <Switch>
        <PrivateRoute exact path="/dashboard" component={Dashboard} />
        <PrivateRoute exact path="/search" component={Search} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/" component={Login} />
        <Route exact path="/testmodal" component={testModal} />
        <Route exact path="/register" component={register} />
        <Route exact path="/passwordreset" component={passwordreset} />
        <Route exact path="/passwordreset/:id" component={passwordreset} />
        <Route exact path="/savedetails" component={savedetails} />
        <Route exact path="/createrole" component={createrole} />
        
        
      </Switch>
    </Router>

  );
}

export default App;
